import moment from 'moment';
import React from 'react';
import { placeholderReplace } from 'src/services/string-helper';
// styles
const styles = require('./highlight-info.scss');
// images
const remember1 = require('../../images/remember_1.svg');
const remember2 = require('../../images/remember_2.svg');
const remember3 = require('../../images/remember_3.svg');

interface IProps {
  headerCenter: boolean;
  language: string;
  languageCode: string;
  multiLang: any;
  airlineCode: string;
  trackingData: any;
  screen: string;
  passengerRules: any;
}

interface IState {
  headerCenter: boolean;
}

class HighlightInfoComponent extends React.Component<IProps, IState> {

  constructor(props: any) {
    super(props);
    this.state = {
      headerCenter: props.headerCenter
    };
  }

  public render() {
    const { multiLang, language, airlineCode, trackingData, screen, passengerRules, languageCode } = this.props;

    const parameters = {
      '{conditionalAcceptanceCutoffTime}': moment(trackingData.conditonalAcceptanceData.cutOffDateTime).format('HH:mm'),
      '{conditionalAcceptanceCutoffTimeDate}': moment(trackingData.conditonalAcceptanceData.cutOffDateTime).format('dddd Do MMMM')
    }

    const isConditonalAcceptance = trackingData.conditonalAcceptanceData.isConditonalAcceptance;
    const destinationCountryCode = trackingData.flightDetails.destinationCountryCode;

    const lufthansaGroupAirlines = ['LX', 'EDW', 'OS', 'DE'];
    const _showUsRules = destinationCountryCode === 'US' && lufthansaGroupAirlines.includes(airlineCode) ? '_USA' : '';

    const conditionalAcceptanceRule =
      screen === 'driver'
        ? 'conditionalAcceptanceRules2'
        : 'conditionalAcceptanceRules1';

    return (
      <div className={styles.wrapper}>
        <div className={this.state.headerCenter ? styles.headerCenter : null}>
          <h2>{multiLang[`dontForgetText${language}`]}</h2>
          <p>
            {multiLang[`requirementsBeforeDriverArriveText${language}`]}
          </p>
        </div>
        <ul className={styles.list}>
          <li>
            <img src={remember1} />
            <p>
              {passengerRules['passengerRules1' + _showUsRules] ? passengerRules['passengerRules1' + _showUsRules][languageCode] : passengerRules['passengerRules1'][languageCode]}
            </p>
          </li>
          <li>
            <img src={remember2} />
            <p>
              {/* LX EDW OS */}
              {isConditonalAcceptance === true
                ? placeholderReplace(
                  passengerRules[conditionalAcceptanceRule + _showUsRules] ? passengerRules[conditionalAcceptanceRule + _showUsRules][languageCode] : passengerRules[conditionalAcceptanceRule][languageCode],
                  parameters
                )
                : passengerRules['identityRules' + _showUsRules] ? passengerRules['identityRules' + _showUsRules][languageCode] : passengerRules['identityRules'][languageCode]}
            </p>
          </li>
          <li>
            <img src={remember3} />
            <p>{passengerRules.phoneRule[languageCode]}</p>
          </li>
        </ul>
      </div>
    );
  }

};

export default HighlightInfoComponent;



// WEBPACK FOOTER //
// ./src/components/highlight-info/highlight-info.component.tsx